import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchPromotions, clearPromotionsErrors, deletePromotion } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  promotions: PropTypes.object,
  onPromotionDisable: PropTypes.func,
  promotionDisabled: PropTypes.bool,
};

class ShowPromotions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.promotionDelete && (this.state.delete || nextProps.promotions.delete)) {
      const promotions = nextProps.promotions;
      promotions.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Promotion deleted!',
        promotions,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleDisable(p) {
    const data = p;
    data.disabled = !p.disabled;
    // Following 2 lines required because Swagger 2 does not support nulable values. - gWilli
    data.startDate = (data.startDate === null) ? '' : data.startDate;
    data.endDate = (data.endDate === null) ? '' : data.endDate;
    delete data.uses;
    delete data.active;
    this.props.onPromotionDisable(data);
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deletePromotion(this.state.deleteId));
    this.props.dispatch(fetchPromotions({ page: 1 }));
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearPromotionsErrors());
    this.props.dispatch(fetchPromotions({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.promotions.results.map((promotion, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{promotion.name}</TableRowColumn>
        <TableRowColumn key={i}>{promotion.promoCode}</TableRowColumn>
        <TableRowColumn key={i}>{(promotion.startDate) ? promotion.startDate.split('T')[0] : null}</TableRowColumn>
        <TableRowColumn key={i}>{(promotion.endDate) ? promotion.endDate.split('T')[0] : null}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDisable={() => this.handleDisable(promotion)}
            onEdit={`/promotions/${promotion.id}`}
            onView={`/promotions/${promotion.id}`}
            disabled={promotion.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Promotion"
          dialogMessage="Do you really want to delete this promotion?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Code</TableHeaderColumn>
              <TableHeaderColumn>Start Date</TableHeaderColumn>
              <TableHeaderColumn>End Date</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowPromotions.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowPromotions.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.promotions.error,
    promotionDelete: state.promotions.promotionDelete,
    promotionDisabled: state.promotions.promotionDisabled,
    promotions: state.promotions,
  };
}

export default connect(mapStateToProps)(ShowPromotions);



// WEBPACK FOOTER //
// ./src/components/promotions/ShowPromotions.js